import { useEffect, useMemo, useState } from 'react';
import { isAgora, isIVS, isVideo, } from '@core/video/videoElementWrapper/helpers';
import { useAnyInteractionState } from '@embed/components/VideoPlayer/Player3/components/Interactions/hooks/useAnyInteractionState/useAnyInteractionState';
import { useRunningAnnouncement } from '@embed/components/VideoPlayer/Player3/components/LiveStreaming/hooks/useRunningAnnouncement';
import { useVideoEl } from '@embed/components/VideoPlayer/Player3/hooks/useVideoEl';
import { AgoraTextCues } from './Agora/AgoraTextCues';
import { useShowSubtitleControls } from './hooks/useShowSubtitleControls';
import { useSubtitles } from './hooks/useSubtitles';
import { VTTTextCues } from './VTT/VTTTextCues';
/**
 * Figures out which specialized text cues component to use, if any, based on wrapper and other criteria
 */
export const TextCues = ({ initialVTTCaption = '' }) => {
    const videoEl = useVideoEl();
    const { subsAreEnabled } = useSubtitles();
    const { showSubtitleControls } = useShowSubtitleControls();
    const [showAutogeneratedMessage, setShowAutogeneratedMessage] = useState(null);
    useEffect(() => {
        setShowAutogeneratedMessage(null);
    }, [videoEl]);
    const { isAnyInteractionVisible } = useAnyInteractionState();
    const runningAnnouncement = useRunningAnnouncement();
    const top = useMemo(() => {
        let top = 64;
        if (runningAnnouncement !== '') {
            top += 36;
        }
        if (isAnyInteractionVisible) {
            top += 50;
        }
        return `${top}px`;
    }, [runningAnnouncement, isAnyInteractionVisible]);
    if (!subsAreEnabled || !showSubtitleControls) {
        return null;
    }
    switch (true) {
        case isVideo(videoEl) || isIVS(videoEl):
            return (<VTTTextCues initialCaption={initialVTTCaption} showAutogeneratedMessage={showAutogeneratedMessage} setShowAutogeneratedMessage={setShowAutogeneratedMessage} top={top}/>);
        case isAgora(videoEl):
            return (<AgoraTextCues showAutogeneratedMessage={showAutogeneratedMessage} setShowAutogeneratedMessage={setShowAutogeneratedMessage} top={top}/>);
    }
    return null;
};
